<template>
  <v-card 
    class="my-3 card-loading"
    style="max-width: 600px; margin: auto"
    flat>
    <v-card-title style="height: 65px">
      <v-layout column>
        <v-layout
          row>
          <v-flex 
            xs5
            px-3
            mt-1>
            <app-progress-bar></app-progress-bar>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-card-title>


    <v-card-text  
      class="card-info">
      <v-layout 
        align-end
        row 
        wrap>
        <v-flex 
          xs12
          md8
          px-3>
          <app-progress-bar></app-progress-bar>
          <app-progress-bar></app-progress-bar>
        </v-flex>

        <!-- <v-flex 
          xs12
          md4
          px-3>
          <app-progress-bar></app-progress-bar>

        </v-flex> -->
      </v-layout>
    </v-card-text>

    <!-- <v-card-text>
    
      <v-flex 
        xs12
        px-3>
        <app-progress-bar></app-progress-bar>

      </v-flex>

    </v-card-text>
   

    <v-divider light></v-divider> -->

    <v-card-actions>
      <v-layout>
        <v-flex 
          xs12
          px-3>
          <app-progress-bar></app-progress-bar>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import ProgressBar from '@/components/global_comps/Cards/CardLoading_progress_bar'

export default {
  components: {
    'app-progress-bar': ProgressBar
  }
}
</script>

<style lang="scss" scoped>
.card-loading {
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid rgba(228, 228, 228, 0.4);
  border-radius: 16px;
  filter: drop-shadow(2px 2px 5px rgba(228, 228, 228, 0.4));
}


.card-info {
  background-color: rgba(228, 228, 228, 0.4);
}

</style>
